export default import.meta.ROLLDOWN_FILE_URL_qshkRZ0DEmujvDHMfSVlug